<template>
  <div class="">
    <h2>{{$t('label.titleEditProfile')}}</h2>
    <div class="wrap-edit">
      <h2>{{$t('label.titleInfoProfile')}}</h2>
      <div class="form-group">
        <label for="name">{{$t('label.account')}}</label>
        <b-form-input v-model="userInfo.username" class="form-control max-width-365" disabled id="name"></b-form-input>
      </div>
      <div class="form-group">
        <label for="inputPassword">{{$t('label.password')}}</label>
        <input  type="password" v-model="userUpdate.password" class="form-control max-width-365" id="inputPassword">
        <span>{{$t('label.descPassword')}}</span>
      </div>
      <div class="form-group">
        <label for="inputName">{{$t('label.name')}}</label>
        <input type="text" v-model="userInfo.fullname" class="form-control max-width-365" id="inputName">
      </div>
      <div class="w-action mt-4">
        <button type="button" class="btn btn-danger" v-on:click="backToDashboard">{{$t('label.back')}}</button>
        <button type="button" class="btn btn-success"v-on:click="updateUserInfo">{{$t('label.save')}}</button>
      </div>

    </div>
  </div>
</template>
<script>
import apiClient from '@/axios'
export default {
  components: {

  },
  data() {
    return {
      userInfo: {
      },
      userUpdate: {
        fullname: '',
        password: '',
      }
    }
  },
  mounted() {
	/*window.addEventListener('resize', this.handleResize)*/
    /*this.handleResize()*/
    this.getUserInfo();
  },
  /*destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },*/
  methods: {
    backToDashboard() {
      this.$router.replace("/admin/dashboard")
    },
    async getUserInfo() {
      let res;
      try {
        res = await apiClient.get('/api/v1/admin/info')
      } catch(error) {
      }
      if (res && res.data) {
        this.userInfo = res.data
      }
    },
    async updateUserInfo() {
      this.userUpdate.fullname = this.userInfo.fullname;
      
      let res;
      try {
        res = await apiClient.post('/api/v1/admin/update',this.userUpdate)
      } catch(error) {
      }
      if (res && res.data) { 
		this.$store.commit("updateFullName", this.userUpdate.fullname)
        this.$bvToast.toast(res.data.message, {
          title: this.$t('label.info'),
          toaster: 'b-toaster-top-right',
          variant: 'primary',
          solid: true,
          appendToast: true
        })
        this.getUserInfo();

      }
    },
    /* handleResize() {
      this.width = window.innerWidth;
      if( this.width < 768){
        this.staked = true;
      } else {
        this.staked = false;
      }
    },*/
  }
}
</script>
